import { guestLinkNameValidator } from '@lucidlink/dto/validation';
import { z } from '@lucidlink/dto/z';
export const guestLinkNameFormParser = z.object({
    name: z.preprocess((value) => (typeof value === 'string' ? value.trim() : value), guestLinkNameValidator),
});
